'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var slideInUp = {
  from: {
    transform: (0, _utils.translate3d)(0, '100%', 0),
    visibility: 'visible'
  },
  to: {
    transform: (0, _utils.translate3d)(0, 0, 0)
  }
};
exports.default = slideInUp;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/slide-in-up.js
// module id = 258
// module chunks = 54990529738226 257444579329143